const NON_RETRYABLE_CODES = new Set(['BAD_REQUEST', 'UNAUTHORIZED', 'FORBIDDEN', 'NOT_FOUND', 'CONFLICT']);

type TrpcLikeError = {
  data?: {
    code?: string;
    httpStatus?: number;
  };
};

export const RETRY_DELAYS_MS = [500, 1500];

export const isRetryable = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null) {
    return true;
  }

  const trpcError = error as TrpcLikeError;
  const code = trpcError.data?.code;
  const status = trpcError.data?.httpStatus;

  if (code && NON_RETRYABLE_CODES.has(code)) {
    return false;
  }

  if (typeof status === 'number' && status >= 400 && status < 500) {
    return false;
  }

  return true;
};
